import { render, staticRenderFns } from "./OrgStaffParalegalStats.vue?vue&type=template&id=28295690&scoped=true&"
import script from "./OrgStaffParalegalStats.vue?vue&type=script&lang=js&"
export * from "./OrgStaffParalegalStats.vue?vue&type=script&lang=js&"
import style0 from "./OrgStaffParalegalStats.vue?vue&type=style&index=0&id=28295690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28295690",
  null
  
)

export default component.exports